import { TimekeeperService } from "services/TimekeeperService";
const tk = new TimekeeperService();
const gettingCreditHolidayRule = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setRows: React.Dispatch<React.SetStateAction<any[]>>) => {
    setLoading(true);

    tk.credit_holiday_rule.getCreditHolidayRules()
        .then((response) => {
            const rows = response.map((response: any) => (
                {
                    id: response.holiday_rule_id,
                    name: response.name,
                    amount_hours: response.amount_hours,
                    enable: response.enable,
                    description: response.description,
                    must_work_shift_before_holiday: response.must_work_shift_before_holiday,
                    must_work_shift_after_holiday: response.must_work_shift_after_holiday,
                    must_work_shift_before_or_after_holiday: response.must_work_shift_before_or_after_holiday,
                    must_work_shift_in_holiday: response.must_work_shift_in_holiday,
                    shift_equivalent_to: response.shift_equivalent_to,
                    credit_type: response.credit_type,
                    if_planned_more_one_shift_in_day: response.if_planned_more_one_shift_in_day,
                    hours_belong: response.hours_belong,
                    zone_holiday_defined_by: response.zone_holiday_defined_by,
                    pay_credits_like: response.pay_credits_like,
                    consider_on_extratime_limit: response.consider_on_extratime_limit,
                    consider_on_extratime_consecutive_days: response.consider_on_extratime_consecutive_days,
                    paycode_extratime_limit_id: response.paycode_extratime_limit_id,
                    paycode_extratime_consecutive_days_id: response.paycode_extratime_consecutive_days_id,
                    paycode_extratime_limit: response.paycode_extratime_limit,
                    paycode_extratime_consecutive_days: response.paycode_extratime_consecutive_days,
                    paycodes: response.paycodes,
                    time_deducted_from_holiday_credit: response.time_deducted_from_holiday_credit,
                    work_rule_id: response.work_rule_id,
                }
            ))
            //console.log(rows)
            setRows(rows);
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
}

const createCreditHolidayRule = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, data: CreditHolidayRuleDB) => {
    setLoading(true);
    //console.log(data)
    return await tk.credit_holiday_rule.createCreditHolidayRule(data)
}

const updateCreditHolidayRule = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, data: CreditHolidayRuleDB, id: number) => {
    setLoading(true);
    //console.log(data)
    return await tk.credit_holiday_rule.updateCreditHolidayRule(id, data)
}

const deleteCreditHolidayRule = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>, id: number) => {
    setLoading(true);
    return await tk.credit_holiday_rule.deleteCreditHolidayRule(id)
}

const gettingAllPaycodes = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
    setLoading(true);
    return await tk.paycodes.getPaycodes("credit_holiday_rule")
}

const gettingAllWorkRules = async (setLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
    setLoading(true);
    return await tk.credit_holiday_rule.getWorkRules()
}

export {
    gettingCreditHolidayRule,
    createCreditHolidayRule,
    updateCreditHolidayRule,
    deleteCreditHolidayRule,
    gettingAllPaycodes,
    gettingAllWorkRules
}